// removed by extract-text-webpack-plugin
module.exports = {"buttonsComplex":"_2Dr8OmPwXkJfiI1DlgGz4S","unselected":"_3yY6l5S-oc-yov0dURXoGj","selected":"BzkTFqFMzgnmAg-2lUGMc"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/ButtonSelection/ButtonSelection.scss
// module id = ./node_modules/wix-style-react/dist/es/src/ButtonSelection/ButtonSelection.scss
// module chunks = 0